export default __webpack_public_path__ + "static/front-heroe2-9c1cfa590f63c8296469a2b2db89b446.png";